import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const SpinnerWrapper = styled.div`
  width: ${({ $size }) => `${$size}px`};
  height: ${({ $size }) => `${$size}px`};
  border-radius: 50%;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 50%;
    background: conic-gradient(${({ $colors }) => $colors.join(', ')});

    mask: radial-gradient(circle, transparent 50%, black 51%);
    -webkit-mask: radial-gradient(circle, transparent 50%, black 51%);

    animation: ${spin} ${({ $speed }) => $speed}s linear infinite;
  }
`;
